// Tag Closuure Warning Widget
import React, { useState } from "react";
import { View, TouchableOpacity,} from "react-native";
import CText from "../../common/CText";
import { COLORS } from "../../constant";
import CView from "../../common/CView";
import CButton from "../../common/CButton";
import CImage from "../../common/CImage";
import * as RootNavigation from "../../utilities/RootNavigation";
import useStyles from "./TagClosure_Styles";


export default function WarningWidget(props) {
    const styles = useStyles();
    const selectedVehicle = props?.selectedVehicle
    const finalRefundAmount = props?.finalRefundAmount || 0
    return(
        <>
        {selectedVehicle?.status == "Hotlisted by service provider" || selectedVehicle?.status == "Hotlisted" || selectedVehicle?.status == "Hotlisted by Operation" ||  finalRefundAmount < 0 ?
                <View style={styles.msgInnerCnt}>
                  <CView FR>
                    <CView MR={20}>
                      <CImage.HotlistErrorIcon></CImage.HotlistErrorIcon>
                    </CView>
                    <View style={styles.WarningWidget}>
                      <CText.warningHeader>{"Warning"}</CText.warningHeader>
                      {selectedVehicle?.status == "Hotlisted" ? <CText.tagWarningText>{"Tag is hotlisted due to low balance"}</CText.tagWarningText> :
                        <CText.tagWarningText>{"Tag is low balance"}</CText.tagWarningText>}
                      <CText.tagWarningDesc>{"Please recharge the TAG for final settlement in order to request Tag Closure. We do not allow hotlisted Tags to close before settlement."}</CText.tagWarningDesc>
                    </View>
                  </CView>
                  <CView FR MT={30}>
                    <TouchableOpacity style={styles.backBtn} onPress={() => {RootNavigation.navigate("servicerequest/selectvehiclefortagclosure") }} >
                      <CText.kycTypeText>{'Back'}</CText.kycTypeText>
                    </TouchableOpacity>
                    <CButton title={'Recharge Tag'} onPress={() => {  RootNavigation.navigate("Recharge") }} style={styles.closeTagBtn} />
                  </CView>
                </View>
                :
                <View style={styles.msgInnerCnt}>
                  <CView  MB={30}>
                    <CView>
                      <CText.warningHeader style={{ color: COLORS.red }}>{"Warning"}</CText.warningHeader>
                      {selectedVehicle?.status == "Blacklisted" || selectedVehicle?.status == "Blacklist" ?
                        <CText.tagWarningText>{"Tag is blacklisted "}</CText.tagWarningText> :
                        <CText.tagWarningDesc style={{ marginTop: 10, textIndent: -5 }}>{"Tag closure cannot be undone. Please be sure you want to close the tag."}</CText.tagWarningDesc>
                      }
                    </CView>
                    {selectedVehicle?.status == "Blacklisted" || selectedVehicle?.status == "Blacklist" ?
                      <CView FR MT={30}>
                        <TouchableOpacity style={styles.backBtn} onPress={() => { 
                          RootNavigation.navigate("servicerequest/selectvehiclefortagclosure")
                           }} >
                          <CText.kycTypeText>{'Back'}</CText.kycTypeText>
                        </TouchableOpacity>
                    </CView>
                    :null}
                  </CView>
                </View>
              }
                 </>
    )
}

